import component from './ToolTip'

export default component
